import request from "../utils/request.js"
// 新增投保需求
export function addUserInsureApi(params) {
    return request({
        url: "/UserInsure/addUserInsure/",
        method: "post",
        data: params,
    })
}
// 新增贷款需求
export function addUserLoanApi(params) {
    return request({
        url: "/UserLoan/addUserLoan/",
        method: "post",
        data: params,
    })
}